<template>
    <v-app>
        <v-app-bar 
            app
            color="secondary"
            dark
            clipped-left
            elevation="0"
            height="45"
        > 
            <div class="d-flex align-center primary--text text-uppercase font-weight-bold">
                <v-img
                alt="Vuetify Logo"
                class="shrink mr-2"
                contain
                src="../assets/logo.jpg"
                transition="scale-transition"
                width="40"
                />
                {{ schoolName }}
                
            </div>
            <v-spacer></v-spacer>
            <v-tooltip 
                bottom
                color="primary"
            >
                <template v-slot:activator="{ on, attrs }">
                    <v-avatar
                        color="white"
                        class="mr-6"
                        size="36"
                        v-bind="attrs"
                        v-on="on"                
                    >
                        <span class="white--text button">{{ initials }}</span>
                    </v-avatar>                    
                </template>
                {{ user }} 
             </v-tooltip>       
            <Logout/>
        </v-app-bar>

        <v-main class="grey lighten-5">
            <InactivityTimer/>
            <v-container
                fluid
                class="pt-0"                
            >
                 <v-row 
                    v-if="welcomeMessage" 
                    class="mt-2 ml-4 mb-6"
                    justify="space-between"
                >
                    <div class="text-body-1 primary--text">Welcome, <span class="font-weight-light font-italic text-h5">{{ user }}</span></div>                                             
                    <div class="text-body-1 primary--text mr-4" >{{ academicPeriod }} </div>
                </v-row>
                
                <v-row>
                    <v-col cols="1">
                        <v-card
                            width="70"
                            flat
                            class="d-flex flex-column align-center grey lighten-5"
                            v-if="mainMenuButton"
                        >
                            <v-expand-transition>
                                <v-btn
                                    color="primary"
                                    dark
                                    fab
                                    small
                                    @click="showMainMenu"    
                                >
                                    <v-icon>
                                        mdi-arrow-left
                                    </v-icon>
                                    
                                </v-btn>
                            </v-expand-transition>
                            <div
                                class="caption mt-2"
                            >
                                Main Menu
                            </div>
                        </v-card>
                    </v-col>

                    <v-col cols="11" class="pt-0">
                        <main-menu v-if="mainMenu"></main-menu>
                        <enter-marks v-if="enterMarks"></enter-marks>
                        <EditViewTermReports v-if="editViewTermReports"></EditViewTermReports>
                        <MarkBook v-if="markBook"></MarkBook>
                        <WeeklyTest v-if="weeklyTest" @show-main-menu="showMainMenu"></WeeklyTest>
                    </v-col>
                </v-row>     
            </v-container> 
        </v-main>        
        <sweet-modal
            :icon="modalIcon"
            ref="modal"
            overlay-theme="dark"
            :title="modalTitle"
            v-on:close="closeSweetModal"
        >
            {{ modalMessage }}
        </sweet-modal>
        <v-overlay
            :value="progressOverlay"
            opacity="0.8"
            z-index="10"                    
        >
            
            <v-progress-circular
                indeterminate
                size="64"
            ></v-progress-circular>                   
        </v-overlay>
    </v-app>
</template>

<script>
import Logout from './auth/Logout';
import MainMenu from './MainMenu';
import EnterMarks from './EnterMarks';
import EditViewTermReports from './EditViewTermReports';
import MarkBook from './MarkBook.vue';
import { mapGetters, mapMutations, mapActions } from 'vuex';
import { SweetModal } from 'sweet-modal-vue';
import InactivityTimer from './InactivityTimer.vue';
import WeeklyTest from './WeeklyTest.vue';

export default {
    name: 'Admin',
    components: {
        Logout,        
        MainMenu,
        EnterMarks,
        EditViewTermReports,
        MarkBook,
        SweetModal, 
        InactivityTimer,   
        WeeklyTest,    
    },

    mounted(){ 
        this.loadTermReports();        
    },
    watch: {
        modal:{
            handler(value){
                console.log('opening modal..')
                if(value) this.openModal();
            }
        }
    },
    computed: {      
        ...mapGetters({
            getUser: 'termReports/getUser',
            schoolName: 'termReports/getSchoolName',            
            user: 'auth/getEmployeeSignedIn',
            initials: 'auth/getEmployeeInitials',
            enterMarks: 'termReports/getEnterMarks',
            editViewTermReports: 'termReports/getEditViewTermReports',
            mainMenu: 'termReports/getMainMenu',
            term: 'termReports/getCurrentTerm',
            year: 'termReports/getCurrentYear',
            modal: 'termReports/getModal',
            modalTitle: 'termReports/getModalTitle',
            modalIcon: 'termReports/getModalIcon',
            modalMessage: 'termReports/getModalMessage',
            welcomeMessage: 'termReports/getWelcomeMessage',
            progressOverlay: 'termReports/getProgressOverlay',
            mainMenuButton: 'termReports/getMainMenuButton',
            currentTerm: 'termReports/getCurrentTerm',
            academicYear: 'termReports/getAcademicYear',
            markBook: 'markBook/getMarkBook',
            weeklyTest: 'weeklyTests/getWeeklyTest', 
            termTest: 'termReports/getTermTest',
            employeeId: 'auth/getEmployeeId',
        }),
        
        academicPeriod () {
            if(this.formTeacherClass) return `${this.formTeacherClass} :  Term ${this.currentTerm}, ${this.academicYear}`
            return `Term ${this.currentTerm}, ${this.academicYear}`
        }
    },
    
    data: () => ({                
        lastLogin: false, 
        formTeacherClass: null,       
    }),
    
    methods: {
        ...mapMutations({
            setMainMenu: 'termReports/setMainMenu',
            setEnterMarks: 'termReports/setEnterMarks',
            setMarkBook: 'markBook/setMarkBook',
            setOverlay: 'termReports/setProgressOverlay',
            setModal: 'termReports/setModal',
            setTable2Records: 'termReports/setTable2Records',
            expand: 'termReports/setExpandLessonOptions',
            setWelcomeMessage: 'termReports/setWelcomeMessage',
            setMainMenuButton: 'termReports/setMainMenuButton',
            setEditViewTermReports: 'termReports/setEditViewTermReports',
            // setExpandEditViewTermReports: 'termReports/setEditViewTermReportsExpand',
            setWeeklyTest: 'weeklyTests/setWeeklyTest',
            setTermTest: 'termReports/setTermTest',
        }),

        ...mapActions({
            currentPeriod: 'termReports/getCurrentAcademicPeriod',
            employee: 'auth/employee',
            getFormTeacherClasses: 'termReports/getAssignedFormTeacherClass',
        }),

        async loadTermReports(){
            this.setOverlay(true);
            try {
                const currentPeriodPromise =  this.currentPeriod();
                const employeePromise = this.employee();
                await currentPeriodPromise;
                await employeePromise;
                const { data: dataFormTeacherClasses } = await this.getFormTeacherClasses(this.employeeId);
                this.formTeacherClass = dataFormTeacherClasses[0]?.class_name;
            } catch (error) {
                if(error.response) console.log(error.response);
                else console.log(error);
            }
            this.setMainMenuButton(false);            
            this.setOverlay(false);
        },

        openModal(){            
            this.$refs.modal.open();
        },

        closeSweetModal () {
            this.setModal(false);
        },

        showMainMenu(){
            //console.log('closing..');            
            this.setTable2Records([]);
            this.setEnterMarks(false);
            this.setEditViewTermReports(false);
            // this.setOverlay(true);
            this.expand(false);
            this.setWelcomeMessage(true);
            this.setMainMenu(true);
            this.setMainMenuButton(false);
            // this.setExpandEditViewTermReports(false);
            this.setMarkBook(false);
            this.setWeeklyTest(false);
            this.setTermTest(false);
        },

        
    }
}
</script>